module.exports = __webpack_public_path__ + "img/touxiang.a185908f.png";